<mat-card>
  <app-card-header
    [title]="title"
    [subtitle]="certificado ? getEntidadInfo() : ''"
    icono="assignment_turned_in"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    @if (certificado) {
      <!-- Datos del certificado -->
      <app-content-card title="Certificado" icon="badge">
        <div class="vce-datos">
          <span class="vce-etiqueta">Entidad</span>
          <span class="vce-valor">{{ getEntidadInfo() }}</span>

          <span class="vce-etiqueta">Fecha de comienzo</span>
          <span class="vce-valor">
            @if (certificado.fechaComienzo) {
              {{ certificado.fechaComienzo | date: 'dd/MM/yyyy HH:mm' }}
            } @else {
              <span class="no-info">Sin fecha</span>
            }
          </span>
        </div>

        <!-- Resumen -->
        <div class="vce-resumen">
          <div class="vce-indicador">
            <mat-icon>fact_check</mat-icon>
            <div>
              <div class="vce-indicador-valor">
                {{ getEstadisticas().codigosEsperados }}
              </div>
              <div class="vce-etiqueta">Códigos esperados</div>
            </div>
          </div>
          <div class="vce-indicador">
            <mat-icon>check_circle</mat-icon>
            <div>
              <div class="vce-indicador-valor">
                {{ getEstadisticas().codigosCumplidos }}
              </div>
              <div class="vce-etiqueta">Cumplidos</div>
            </div>
          </div>
          <div class="vce-indicador">
            <mat-icon>trending_up</mat-icon>
            <div>
              <div class="vce-indicador-valor">
                {{ getEstadisticas().porcentajeCumplimiento }} %
              </div>
              <div class="vce-etiqueta">Cumplimiento</div>
            </div>
          </div>
        </div>
      </app-content-card>

      <!-- Tabla de códigos -->
      <app-content-card title="Comparación de códigos" icon="list">
        <div class="vce-tabla-contenedor">
          <table mat-table [dataSource]="codigosComparacion" class="vce-tabla">
            <!-- Código -->
            <ng-container matColumnDef="codigo">
              <th mat-header-cell *matHeaderCellDef>Código</th>
              <td mat-cell *matCellDef="let row" class="vce-codigo">
                {{ row.codigo }}
              </td>
            </ng-container>

            <!-- Descripción -->
            <ng-container matColumnDef="descripcion">
              <th mat-header-cell *matHeaderCellDef>Descripción</th>
              <td mat-cell *matCellDef="let row">{{ row.descripcion }}</td>
            </ng-container>

            <!-- Generado -->
            <ng-container matColumnDef="generado">
              <th mat-header-cell *matHeaderCellDef class="vce-centro">
                Generado
              </th>
              <td mat-cell *matCellDef="let row" class="vce-centro">
                @if (row.generado) {
                  <mat-icon class="vce-si">check_circle</mat-icon>
                } @else {
                  <mat-icon class="vce-no">cancel</mat-icon>
                }
              </td>
            </ng-container>

            <!-- Fecha del último evento -->
            <ng-container matColumnDef="fechaUltimo">
              <th mat-header-cell *matHeaderCellDef>Hora reportado</th>
              <td mat-cell *matCellDef="let row">
                @if (row.fechaUltimoEvento) {
                  {{ row.fechaUltimoEvento | date: 'dd/MM/yyyy HH:mm' }}
                } @else {
                  <span class="no-info">Sin reporte</span>
                }
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: columnsToDisplay"
              [ngClass]="getRowClass(row)"
            ></tr>
          </table>
        </div>

        <!-- Leyenda -->
        <div class="vce-leyenda">
          <span class="vce-leyenda-item">
            <span class="vce-leyenda-color row-success"></span>
            Generado
          </span>
          <span class="vce-leyenda-item">
            <span class="vce-leyenda-color row-warning"></span>
            No generado
          </span>
          <span class="vce-leyenda-item">
            <span class="vce-leyenda-color row-info"></span>
            Generado sin estar esperado
          </span>
        </div>
      </app-content-card>
    } @else {
      <span class="no-info">Sin información del certificado</span>
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="cerrar()">
      Cerrar
    </button>
    @if (certificado) {
      <button irxBoton="principal" type="button" (click)="exportar()">
        <mat-icon>file_download</mat-icon>
        Exportar
      </button>
    }
  </mat-card-actions>
</mat-card>
